import { StructureBlockAddress as StructureBlockAddressBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import StructureBlockAddressNodeView from '@/components/editor/StructureBlockAddressNodeView'

export const StructureBlockAddress = StructureBlockAddressBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(StructureBlockAddressNodeView)
    },
})
